/* tslint:disable */

declare var Object: any;
export interface SFBPJSTKReportInterface {
  "id"?: number;
}

export class SFBPJSTKReport implements SFBPJSTKReportInterface {
  "id": number;
  constructor(data?: SFBPJSTKReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBPJSTKReport`.
   */
  public static getModelName() {
    return "SFBPJSTKReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBPJSTKReport for dynamic purposes.
  **/
  public static factory(data: SFBPJSTKReportInterface): SFBPJSTKReport{
    return new SFBPJSTKReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBPJSTKReport',
      plural: 'sfbpjstkreport',
      path: 'sfbpjstkreport',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBPJSTKReport.ts